import IncTextField from '../fields/inc-text-field/inc-text-field.component';
import { useTranslation } from 'react-i18next';

const LoyaltyPointsForm = () => {
  const { t } = useTranslation();

  return (
    <>
      <IncTextField
        name="points"
        label={t('page.customers.form.loyalty.numberOfPoints')}
        data-testid="LoyaltyPointsForm.IncTextField.points"
      />
      <IncTextField
        name="reason"
        label={t('page.customers.form.loyalty.reasonForAdjustment')}
        data-testid="LoyaltyPointsForm.IncTextField.reason"
        multiline
        rows={4}
      />
    </>
  );
};

export default LoyaltyPointsForm;
